module.exports = "precision highp float;\n\nVERT_IN vec3 a_position;\n\nvoid main() {\n\n  gl_Position = vec4(a_position, 1.0);\n\n}\n"